window.__assetPrefix__ = 'http://localhost:3200';